import React from 'react';
import { Table as Bs5 } from 'react-bootstrap5';

const Bs5Table = zProps => {
  // keep using this translation from condensed to size="sm" for now, because
  // `condensed` is being used in many places still
  const { condensed, ...props } = zProps;
  if (condensed) props.size = 'sm';
  return <Bs5 {...props} />;
};

const Table = Bs5Table;

export default Table;
